export const minerals = [
    { name: 'Alumina', symbol: 'Al₂O₃', atomic_number: null },
    { name: 'Aluminum', symbol: 'Al', atomic_number: 13 },
    { name: 'Antimony', symbol: 'Sb', atomic_number: 51 },
    { name: 'Cerium', symbol: 'Ce', atomic_number: 58 },
    { name: 'Cobalt', symbol: 'Co', atomic_number: 27 },
    { name: 'Dysprosium', symbol: 'Dy', atomic_number: 66 },
    { name: 'Erbium', symbol: 'Er', atomic_number: 68 },
    { name: 'Europium', symbol: 'Eu', atomic_number: 63 },
    { name: 'Gadolinium', symbol: 'Gd', atomic_number: 64 },
    { name: 'Gallium', symbol: 'Ga', atomic_number: 31 },
    { name: 'Germanium', symbol: 'Ge', atomic_number: 32 },
    { name: 'Graphite', symbol: 'C', atomic_number: 6 },
    { name: 'Holmium', symbol: 'Ho', atomic_number: 67 },
    { name: 'Lanthanum', symbol: 'La', atomic_number: 57 },
    { name: 'Lithium', symbol: 'Li', atomic_number: 3 },
    { name: 'Lutetium', symbol: 'Lu', atomic_number: 71 },
    { name: 'Magnesium', symbol: 'Mg', atomic_number: 12 },
    { name: 'Manganese', symbol: 'Mn', atomic_number: 25 },
    { name: 'Ndpr', symbol: 'NdPr', atomic_number: null },
    { name: 'Neodymium', symbol: 'Nd', atomic_number: 60 },
    { name: 'Nickel', symbol: 'Ni', atomic_number: 28 },
    { name: 'Palladium', symbol: 'Pd', atomic_number: 46 },
    { name: 'Praseodymium', symbol: 'Pr', atomic_number: 59 },
    { name: 'Rare earth oxide', symbol: 'REO', atomic_number: null },
    { name: 'Samarium', symbol: 'Sm', atomic_number: 62 },
    { name: 'Terbium', symbol: 'Tb', atomic_number: 65 },
    { name: 'Tungsten', symbol: 'W', atomic_number: 74 },
    { name: 'Yttrium', symbol: 'Y', atomic_number: 39 },
    { name: 'Zinc', symbol: 'Zn', atomic_number: 30 },
  ].sort((a, b) => a.name.localeCompare(b.name));